module.exports = __webpack_public_path__ + "static/media/welcome_sound.35b1da0e.mp3";